
let AdminLocaleSwitcher = (() => {
    const $route = '/change_locale';

    let init = () => {
        const $select = $('#header-locale-switcher');

        $select.on('change', function() {
            let localeCode = $(this).val();

            $.get($route, {
                code: localeCode
            }).then(() => {
                location.reload();
            });
        });
    };

    return {
        init: init,
    };
})();

export default AdminLocaleSwitcher;
